import type { IArrivalReasonSource } from '@talbenmoshe/trip-os-react-model';
import type { ISearchableLocation } from './LocationReturnAddressSource.js';

/** Reads `reason` from the login page's own address (the sign-out sends `reason=signed-out`); passed on unvalidated. */
export class LocationArrivalReasonSource implements IArrivalReasonSource {
  constructor(private readonly location: ISearchableLocation) {}

  getArrivalReason(): string | undefined {
    return new URLSearchParams(this.location.search).get('reason') ?? undefined;
  }
}
